const hasLocalhost = (hostname: string) =>
  Boolean(
    hostname.match(/localhost/) ||
    hostname.match(/127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}/),
  );
const isLocalhost = hasLocalhost(window.location.hostname);

export const environment = {
  region: 'eu-west-1',
  userPoolId: 'eu-west-1_IQ912epFt',
  userPoolClientId: '6nkkg8jfmc4euqr2k191q132gu',
  cognitoDomain: 'drx-clle-dev',
  publicApiUrl: "https://public-api.clle.dev.hourly-associates.draexlmaier.solutions",
  redirectSignIn: isLocalhost
    ? 'http://localhost:4200/secure'
    : 'https://clle.dev.hourly-associates.draexlmaier.solutions/secure',
  redirectSignOut: isLocalhost
    ? 'http://localhost:4200/public'
    : 'https://clle.dev.hourly-associates.draexlmaier.solutions/public',
};
